import React from "react";

const CARD = "bg-white rounded-2xl border border-[#EBE9E4] shadow-[0_8px_30px_rgba(45,45,45,0.04)]";
const COLS = { 4: "lg:grid-cols-4", 5: "lg:grid-cols-5", 6: "lg:grid-cols-6", 7: "lg:grid-cols-7" };

export function StatStrip({ items, testid = "stat-strip", cols = 5 }) {
  const colCls = COLS[cols] || COLS[5];
  return (
    <div className={`grid grid-cols-2 md:grid-cols-4 ${colCls} gap-3`} data-testid={testid}>
      {items.map((s) => {
        const Icon = s.icon;
        return (
          <div key={s.key} className={`${CARD} p-4`} data-testid={`${testid}-${s.key}`}>
            <div className="flex items-center gap-2 mb-1">
              <div className="h-7 w-7 rounded-lg flex items-center justify-center" style={{ background: "#0B5E4E1A" }}>
                {Icon && <Icon className="h-3.5 w-3.5" style={{ color: "var(--sj-primary)" }} />}
              </div>
              <span className="text-[11px] font-semibold uppercase tracking-wide truncate" style={{ color: "var(--sj-text-3)" }}>{s.label}</span>
            </div>
            <div className="font-head text-2xl font-extrabold" style={{ color: "var(--sj-text)" }}>
              {s.value ?? 0}{s.suffix || ""}
            </div>
          </div>
        );
      })}
    </div>
  );
}
